<div class="usuario-infobar" *ngIf="entity">
    <div class="usuario-infobar-header">
        <ng-template [ngIf]="canUploadAvatar">
            <sgt-usuario-avatar-upload
                [entity]="entity">
            </sgt-usuario-avatar-upload>
        </ng-template>
        <ng-template [ngIf]="!canUploadAvatar">
            <sgt-avatar
                [settings]="avatarSettings">
            </sgt-avatar>
        </ng-template>

        <h5 class="usuario-infobar-nome">
            {{entity.nome}}
        </h5>
        <small class="usuario-infobar-login text-muted">
            {{entity.login}}
        </small>
    </div>
</div>
